import { stripTags } from "../stripTags";

/**
 * Sanitizes user input from unwanted chars and multiple spaces
 * @param {string} input 
 * @param {boolean} shouldStripTags
 * @param {number} consequentNewLinesAllowedCount 
 */
export const sanitizeUserInput = function(input, shouldStripTags = true, consequentNewLinesAllowedCount = 2) {
    if (!input)
        return '';

    // Normalize
    let output = input.trim();
    if (shouldStripTags)
        output = stripTags(output);

    // Replace CRLF with LF
    output = output.replace(/\r\n/g, '\n');
    // Replace multiple new lines
    output = output.replace(new RegExp(`([\\n]{${consequentNewLinesAllowedCount},${consequentNewLinesAllowedCount}})[\\n]+`, 'g'), '$1');
    // Replace multiple spaces
    // Can't use \s as it includes \n chars and effectively removes new lines
    output = output.replace(/[\t ]+/g, ' ');
    // Remove spaces from the start and end of each line
    output = output.replace(/(\n | \n)/g, '\n');

    return output;
}